import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faSquareInstagram } from '@fortawesome/free-brands-svg-icons';



function FooterBottom() {

  const styles = `
  .footer-background {
  background-color: #3A3A3A;
  padding: 40px 10px;
}

.bottom-footer {
  background-color: #202020;
}

.inner-content {
  width: 85%;
  margin: 0 auto;
  border-bottom: 1px solid rgb(115 115 115);
  padding-bottom: 20px;
}

.gov-links-images {
  display: flex;

  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  gap: 10px;
}

.gov-links-images img {
  max-width: 100%;
  height: auto;

}

.footer-separater-line {
  color: #fff;
  height: 10px;
}

.help-just {
  text-align: justify;
}

/*------------------------------------middle part footer------------------------*/
/* ----------------footer section-------------------- */
.footer-section {
  background-color: #3A3A3A;
  color: #fff;
  font-family: "Noto Sans", sans-serif;
  margin: -5px 0px;
}

.footer-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 30px;
  width: 85%;
  margin: auto;
}

.footer-col .ulist,
.ulist2,
.ulist3 {
  list-style-type: none;
  padding: 0px;
  margin-bottom: 7px;
}

.ulist2 {
  padding-top: 30px;
}

.footer-col h3 {
  text-decoration: underline;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;

}

.uilist-marg {
  margin-top: 33px;
}

.footer-col h3:hover {
  color: #FFBE0B;
}

.footer-col ul li a:hover {
  text-decoration: underline;
  color: #FFBE0B;
}

.ulist3 li a {
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;

}

.footer-col ul li {
  margin-bottom: 10px;
}

.ulist li a,
.ulist2 li a {
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}

/* ------------------------------------------- */
.social-links a {
  text-decoration: none;
}

.social-links {
  display: flex;
}

.social-links .link-icon {
  color: #fff;
  transition: color 0.2s ease;
}

.social-links .facebook {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #3e3e3e;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  transition: background-color 0.2s ease;
}

.social-links .facebook:hover {
  background-color: #fff;

}

.social-links .facebook:hover .link-icon {
  color: #3510d6;

}

/*------------------------Bottom footer-----------------------------*/
.bootom-footer-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bootom-footer a {
  text-decoration: none !important;
  color: #fff !important;
}


.left-part-footer {
  background-color: #101010;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

}

.left-part-footer h4 {
  color: #fff;
  font-family: "Noto Sans", sans-serif;
  font-size: 16px;
  line-height: 1.3;
  margin-bottom: 0px;
  font-weight: 500;
  text-align: center;
}


.right-part-footer {
  padding: 15px 15px 15px 20px;

}

.right-part-footer p {
  color: #fff;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  line-height: 1.3;
  margin-bottom: 0px;
  font-weight: 400;

}

.bottom-footer-inner-container {
  width: 85%;
  margin: 0px auto;
}

/*------------------------brand-bottom-footer-----------------------*/
.brand-bottom-footer {
  background-color: #1a237e;
  padding: 10px;
}

.brand-bottom-inner-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.text1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  padding-right: 6%;
}

.footer-p1,
.footer-p3 {
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.4;
  margin-bottom: 0px;
}

/* ===================image marquee css==================== */
/* ================Marquee css========================= */
.marquee-wrapper {
  overflow: hidden;
  background: #fff;
}

.marquee {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.marquee-content {
  display: flex;
  gap: 40px;
  animation: scroll-left 20s linear infinite;
}

/* Pause the marquee on hover */
.marquee-content:hover {
  animation-play-state: paused;
}

.marquee-content img {
  width: 180px;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

/* Animation */
@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

/* ===================image marquee css==================== */
/*=================Site Map Css=======================*/
.sitemap {
  margin-top: 110px;
}

.sitemap ul {
  list-style: none;
  padding-left: 20px;
  position: relative;
}

.sitemap ul::before {
  content: "";
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  border-left: 1px solid #ccc;
}

.sitemap li {
  position: relative;
  margin: 8px 0;
  padding-left: 30px;
}

.sitemap li::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 15px;
  width: 39px;
  height: 1px;
  background: #ccc;
}



.sitemap a:hover::before {
  width: 120%;
  left: 0;
}

.sitemap a::before {
  content: "";
  position: absolute;
  top: 0;
  left: -20%;
  width: 0;
  height: 100%;
  border-radius: 6px;
  z-index: -1;
  transition:
    width 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    left 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.sitemap a {
  display: inline-block;
  background: #f8f9fa;
  border: 1px solid #d1d1d1;
  padding: 6px 10px;
  border-radius: 3px;
  text-decoration: none;
  color: #000;
  font-weight: 400;
  transition: transform 0.4s ease-in-out;
  font-family: Poppins, sans-serif;
}

.sitemap a:hover {
  transform: translateX(15px);
}

  `
  return (
    <>
    <style>{styles}</style>
      {/*----------------------------------footer-Top part----------------------------------*/}
      <Container fluid className="px-0">
        <div className="footer-background">
          <Container fluid>
            <div className="inner-content">
              <div className="marquee">
                <div className="marquee-content">
                  {/* Duplicate images for smooth infinite scroll */}
                  <img src="/images/slide-logo8.svg" alt="img1" />
                  <img src="/images/slide-logo7.svg" alt="img1" />
                  <img src="/images/slide-logo6.svg" alt="img2" />
                  <img src="/images/slide-logo5.svg" alt="img3" />
                  <img src="/images/slide-logo4.svg" alt="img4" />
                  <img src="/images/slide-logo3.svg" alt="img4" />
                  <img src="/images/slide-logo2.svg" alt="img4" />
                  <img src="/images/slide-logo1.svg" alt="img4" />
                  <img src="/images/slide-logo8.svg" alt="img1" />
                  <img src="/images/slide-logo7.svg" alt="img1" />
                  <img src="/images/slide-logo6.svg" alt="img2" />
                  <img src="/images/slide-logo5.svg" alt="img3" />
                  <img src="/images/slide-logo4.svg" alt="img4" />
                  <img src="/images/slide-logo3.svg" alt="img4" />
                  <img src="/images/slide-logo2.svg" alt="img4" />
                  <img src="/images/slide-logo1.svg" alt="img4" />
                </div>
              </div>


            </div>
          </Container>
        </div>
      </Container>
      {/*----------------------------middle-part-----------------------------------------*/}
      <div className='footer-section' id='footer-section'>
        <Container fluid>
          <footer >
            <Container>
              <Row>
                <Col xxl={1} xl={1} lg={1} md={0} sm={0} xs={0}></Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col">
                    <h3>Related Links</h3>
                    <ul className='ulist '>
                      <li> <a href="https://ap.gov.in/#/" target="_blank" rel="noopener noreferrer">AP State Portal</a></li>
                      <li><a href="https://apfinance.gov.in/" target="_blank" rel="noopener noreferrer">AP Finance</a></li>
                      <li><a href="https://cfms.ap.gov.in/" target="_blank" rel="noopener noreferrer">CFMS</a></li>
                      <li><a href="https://www.pppinindia.gov.in/" target="_blank" rel="noopener noreferrer">PPP India</a></li>
                      <li><a href="https://www.india.gov.in/" target="_blank" rel="noopener noreferrer">National Portal of India</a></li>
                    </ul>
                  </div>
                </Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col">
                    <h3>Policies</h3>
                    <ul className='ulist'>
                      <li><a href="/CopyRight"  onClick={(e) => e.preventDefault()} rel="noopener noreferrer">Copyright Policy</a></li>
                      <li><a href="/PrivacyPolicy" onClick={(e) => e.preventDefault()}  rel="noopener noreferrer">Privacy Policy</a></li>
                      <li><a href="/HyperLink" onClick={(e) => e.preventDefault()}  rel="noopener noreferrer">Hyperlinking Policy</a></li>
                      <li><a href="/TermsUse" onClick={(e) => e.preventDefault()}  rel="noopener noreferrer">Terms of Use</a></li>
                    </ul>
                  </div>
                </Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col">
                    <ul className='ulist uilist-marg'>
                      <li><a href="/AboutUs" onClick={(e) => e.preventDefault()}  >About Us</a></li>
                      <li><a href="/ContactPage" onClick={(e) => e.preventDefault()}  >Contact Us</a></li>
                      <li><a href="/Feedback" onClick={(e) => e.preventDefault()} >Feedback</a></li>
                      <li><a href="/Faq" onClick={(e) => e.preventDefault()} >FAQs</a></li>
                      <li><a href="/Helpsection" onClick={(e) => e.preventDefault()} >Help</a></li>
                    </ul>
                  </div>
                </Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col">

                    <ul className='ulist uilist-marg'>
                      <li><a href="/Sitemap" onClick={(e) => e.preventDefault()} >Site Map</a></li>
                      <li><a href="/Website" onClick={(e) => e.preventDefault()}  >Website Policy</a></li>
                      <li><a href="/Disclaimer" onClick={(e) => e.preventDefault()}  rel="noopener noreferrer">Disclaimer</a></li>
                    </ul>
                  </div>
                </Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col ">
                    <h3>Follow Us</h3>

                    <div className="social-links">
                      <a href="#" target="_blank" onClick={(e) => e.preventDefault()} >
                        <div className="facebook">
                          <FontAwesomeIcon icon={faFacebookF} className='link-icon' />
                        </div>
                      </a>
                      <a href="#" target="_blank" onClick={(e) => e.preventDefault()} >
                        <div className="facebook">
                          <FontAwesomeIcon icon={faYoutube} className='link-icon' />
                        </div>
                      </a>
                    </div>
                  </div>
                </Col>
                <Col xxl={1} xl={1} lg={1} md={0} sm={0} xs={0}></Col>
              </Row>
              <div className='right-part-footer'>

                <p>All information, data, and materials published on this portal are owned and approved by the Director, Andhra Pradesh Government Life Insurance Department. The Director is responsible for ensuring the accuracy, authenticity, and timely updating of the content displayed on this website.</p>
              </div>
            </Container>
          </footer>
        </Container>
      </div>
      {/*---------------------------------------bottom-footer---------------------------------------*/}
      <div className="container-fluid bottom-footer">
        <div className="bottom-footer-inner-container">
          <div className="bootom-footer-content">
            <Row>
              <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12}>
                <div class="left-part-footer">
                  <h4>Translation Disclaimer</h4>
                </div>
              </Col>
              <Col xxl={10} xl={10} lg={10} md={10} sm={12} xs={12}>
                <div className="right-part-footer">
                  <p>This website has been translated into multiple languages for the convenience of users. While every effort has been made to ensure the accuracy, correctness, and reliability of the translated content, the English version (or original language version) shall prevail in case of any variation or discrepancy. The translated content is provided through automated/assisted translation tools, and therefore may not be fully accurate or reflect the intended meaning of the original text.
                    The Department / Organisation does not accept any responsibility for errors or omissions that may occur due to translation. Users are advised to refer to the original version of the website for official and legally valid information. If any inconsistency is observed, kindly report it to the website administrator for corrective action.</p>
                </div>
              </Col>
            </Row>
          </div>

        </div>
      </div>
      <div className="container-fluid brand-bottom-footer">
        <div class="brand-bottom-inner-footer">
          <div>
            <p className="footer-p1">
              Copyright © 2026 Directorate of Economics & Statistics All Rights Reserved
            </p>
          </div>
      
          <div className="text1">
            <p className="footer-p3">Designed and developed by</p>
            <a href="https://apcfss.in/" target="_blank">
              <img src="../images/apcfss-logo-white.svg"
                className="footer-image img-fluid"
              />
            </a>
          </div>
        </div>
      </div>
    </>

  );
}

export default FooterBottom;